import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Label } from "reactstrap";

interface TypesProps {
  name?: string;
  onSetValueAddress?: (params: any) => void;
}

declare global {
  interface Window {
    flutter_inappwebview: any;
    daum: any;
  }
}

//declare const window: any;

const SearchAddress = ({ name = "", onSetValueAddress }: TypesProps) => {
  const { t } = useTranslation();
  const handleGetAddress = () => {
    try {
      var element_layer = document?.getElementById("layer");
      if (element_layer && window?.daum) {
        new window.daum.Postcode({
          oncomplete: (data: any) => {
            console.log(data, "data")
            onSetValueAddress && onSetValueAddress(data?.address);
            window?.flutter_inappwebview?.callHandler("oncomplete", data);
          },
          // }).open();
          width: "100%",
          height: "100%",
        }).embed(element_layer);
        element_layer.style.display = "block";
      }
    } catch (error) {
      alert(error);
    }
  };

  useEffect(() => {
    handleGetAddress();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <React.Fragment>
      <div className="mb-3 pb-2">
        <Label htmlFor="address" className="form-label">
          {t("Address")}
        </Label>

        <div style={{ display: "flex", justifyContent: "center" }}>
          <div
            id={`layer`}
            style={{ display: "block", width: "100vw", height: "50vh" }}
          ></div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default SearchAddress;
